import styles from './Header.module.scss';

function Header() {
  return (
    <header className={ styles.header }>
      <div className={ styles.container }>
        <a href="https://complexchinese.com/" target="_blank" rel="noreferrer">
          <img src={ `${process.env.PUBLIC_URL}/images/logo.png` } alt="COMPLEX 中文" className={ styles.logo } />
        </a>
      </div>
    </header>
  );
}

export default Header;
